
import {Pipe, PipeTransform} from '@angular/core';
import { environment } from '@environments/environment';

@Pipe({
    name: 'env',
    standalone: false
})
class EnvPipe implements PipeTransform 
{
    transform(variable: string): any 
    {
        return environment[variable];
    }
}
export { EnvPipe };